import { render, staticRenderFns } from "./VText.vue?vue&type=template&id=6afb7684&scoped=true&v-if=tag%20%3D%3D%3D%20'p'"
import script from "./VText.vue?vue&type=script&lang=ts"
export * from "./VText.vue?vue&type=script&lang=ts"
import style0 from "./VText.vue?vue&type=style&index=0&id=6afb7684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb7684",
  null
  
)

export default component.exports